module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/sweatshirt/4-1-68aafbbd8e0e17082562a402bb831dab.jpg";